import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { Toast_Func } from 'src/helper/toast.helper';
import { IAccountStatus } from 'src/models/misc';

import {
  API_CODE_MESSAGES,
  CODE_CLOSE_MODAL_SUCCESS,
  CODE_EMAIL_VERIFICATION,
  CODE_ROUTE_TO_SIGNUP,
} from '../constants';
import { customerBusinessService } from '../services';

interface locationState {
  text: string;
  header: string;
  email: string;
}

const useVerifyAccount = (
  accountStatusModal: IAccountStatus,
  setAccountStatusModal: any,
) => {
  const location = useLocation();
  const history = useHistory();
  const cartDispatch = useDispatch();
  const user = new URLSearchParams(location.search).get('user');
  const code = new URLSearchParams(location.search).get('code');
  const id = new URLSearchParams(location.search).get('id');

  const [isVerifyingEmailLink, setIsVerifyingEmailLink] =
    useState<boolean>(false);

  const state = location.state as locationState;
  useEffect(() => {
    if (
      state?.header &&
      state?.text &&
      state?.email &&
      !accountStatusModal.show
    ) {
      setAccountStatusModal({
        code: CODE_EMAIL_VERIFICATION,
        buttonText: API_CODE_MESSAGES[CODE_EMAIL_VERIFICATION],
        isError: false,
        header: state.header,
        text: state.text,
        email: state.email,
        show: true,
      });
      delete state.header;
      delete state.text;
      delete state.email;
      history.replace({ ...history.location, state });
    }
  }, [state?.header]);
  useEffect(() => {
    const verifyEmailLink = async () => {
      try {
        setIsVerifyingEmailLink(true);
        const response = await customerBusinessService.verifyEmailLink({
          code,
          user,
          id,
        });
        setAccountStatusModal({
          code: CODE_CLOSE_MODAL_SUCCESS,
          isError: false,
          buttonText: 'Sign In',
          header: response.data.data.header,
          text: response.data.data.text,
          email: '',
          show: true,
        });
      } catch (error) {
        const errorsObject = error.response?.data?.errors;
        if (errorsObject?.header)
          setAccountStatusModal({
            code: CODE_ROUTE_TO_SIGNUP,
            isError: true,
            buttonText: 'Sign Up',
            header: errorsObject.header,
            text: errorsObject.text,
            email: '',
            show: true,
          });
        else
          Toast_Func({
            status: false,
            message: errorsObject?.[0] || error.response?.data?.message,
          });
      } finally {
        setIsVerifyingEmailLink(false);
        history.replace({
          search: '',
        });
      }
    };
    if (user && code && id) verifyEmailLink();
  }, []);
  return { isVerifyingEmailLink };
};

export default useVerifyAccount;
